if (!customElements.get('shp-owner-stories')) {
  customElements.define('shp-owner-stories', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.shp-owner-stories__track');
      let scrollTimer;

      track?.addEventListener('scroll', () => {
        track.classList.add('is-scrolling');
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => track.classList.remove('is-scrolling'), 650);
      }, { passive: true });

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-shp-owner-play]');
        if (!trigger || !this.contains(trigger)) return;

        const story = trigger.closest('[data-shp-owner-story]');
        const template = story?.querySelector('template[data-shp-owner-video]');
        const media = story?.querySelector('[data-shp-owner-media]');
        if (!template || !media) return;

        this.querySelectorAll('video').forEach((video) => video.pause());
        media.replaceChildren(template.content.cloneNode(true));
        const video = media.querySelector('video');
        if (video) {
          video.classList.add('shp-owner-story__video');
          video.play().catch(() => {});
        }
      });
    }
  });
}
